export const GET_MY_TEMPLATE_REQUEST = 'GET_MY_TEMPLATE_REQUEST';
export const GET_MY_TEMPLATE_SUCCESS = 'GET_MY_TEMPLATE_SUCCESS';
export const GET_MY_TEMPLATE_FAIL = 'GET_MY_TEMPLATE_FAIL';
